import React, { useState, useEffect } from "react"
import 'bootstrap/dist/css/bootstrap.min.css';
import DOMPurify from "dompurify";
import MySideNav from './components/MySideNav'
import MyNav from './components/MyNav'
import Content from './components/Content'
import GetParams from './params'
import logo from './logo.svg';
import axios from "axios";
import md5 from 'md5';
import $ from 'jquery';
import { PersonCircle, CardText, GearFill, BarChartFill, ArrowRight, HouseDoorFill, ImageFill, PersonSquare, BoxArrowRight, FileEarmarkCheckFill } from 'react-bootstrap-icons';
import './App.css';
import './Adl.css';
import './Nav.css';
import { sanitizeInput } from './sanitizeInput';
// import {user, userEmail} from `./components/MyNav`;
import frm from './components/formAux.js'

import { CheckQA } from "./components/NlpSetup.js";

console.log('wpw', window.GlobalVars)

window.pageHash = document.location.hash;
window.frm = frm;

// alert( document.location )

window.clone = function(o) { return JSON.parse(JSON.stringify(o)); }
window.diffObj = function(a,b) { return JSON.stringify(a) != JSON.stringify(b) };

function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object && !isarray(o);}
function clone(o) { return JSON.parse(JSON.stringify(o)); }

var pages = [];
var menu = [
    { id: 'nlpProjectBrowse', nav: 'Projects', name: 'Projects', ficon: '<i class="fa fa-file-text"></i>', type: { admin: 1, c_admin: 1, c_super: 1, c_viewer: 1 } },
    { id: 'datasets', name: 'Datasets', ficon: '<i class="fa fa-database"></i>', type: { admin: 1, c_admin: 1, d_super: 1, d_viewer: 1 } },
    { id: 'datasetSetup', skip: true, name: 'Dataset Setup', ficon: '<i class="fa fa-database"></i>', type: { admin: 1, c_admin: 1, d_super: 1, d_viewer: 0 } },
    { id: 'datasetExports', skip: true, name: 'Dataset Exports', ficon: '<i class="fa fa-database"></i>', type: { admin: 1, c_admin: 1, d_super: 1, d_viewer: 1 } },
    { id: 'datasetModelRuns', skip: true, name: 'Dataset Model Runs', ficon: '<i class="fa fa-sitemap"></i>', type: { admin: 1, c_admin: 1, d_super: 1, d_viewer: 1 } },
    { id: 'projectExports', skip: true, name: 'Project Exports', ficon: '<i class="fa fa-database"></i>', type: { admin: 1, c_admin: 1, c_super: 1, c_viewer: 1 } },
    { id: 'datasetTeam', skip: true, name: 'Dataset Team', ficon: '<i class="fa fa-database"></i>', type: { admin: 1, c_admin: 1, d_super: 1, d_viewer: 0 } },
    { id: 'datasetUpload', skip: true, name: 'Dataset Upload', ficon: '<i class="fa fa-database"></i>', type: { admin: 1, c_admin: 1, d_super: 1, d_viewer: 0 } },
    { id: 'datasetRecipes', skip: true, name: 'Dataset Recipes', ficon: '<i class="fa fa-database"></i>', type: { admin: 1, c_admin: 1, d_super: 1, d_viewer: 1 } },
    { id: 'datasetRecipeView', skip: true, name: 'Dataset Prompt Runs', ficon: '<i class="fa fa-database"></i>', type: { admin: 1, c_admin: 1, d_super: 1, d_viewer: 1 } },
    { id: 'datasetChatBot', skip: true, name: 'Chatbot', ficon: '<i class="fa fa-database"></i>', type: { admin: 1, c_admin: 1, d_super: 1, d_viewer: 1 } },
    { id: 'nlpImport', skip: true, nav: 'PDF Docs', name: 'Project Basic Settings', ficon: '<i class="fa fa-file-text-o"></i>', type: { admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'nlpImport1', skip: true, nav: 'PDF Docs1', name: 'Project Basic Settings', ficon: '<i class="fa fa-file-text-o"></i>', type: { admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'nlpImport2', skip: true, nav: 'PDF Docs2', name: 'Project Labels', ficon: '<i class="fa fa-file-text-o"></i>', type: { admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'nlpImport3', skip: true, nav: 'PDF Docs3', name: 'Project Advanced Settings', ficon: '<i class="fa fa-file-text-o"></i>', type: { admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'fileupload', skip: true, name: 'Project Datasets', ficon: '<i class="fa fa-upload"></i>', type: { admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'nlpBrowse', skip: true, nav: 'PDF Docs', name: 'Browse Tasks', ficon: '<i class="fa fa-file-text-o"></i>', type: { admin: 1, c_admin: 1, c_super: 1, c_viewer: 1 } },
    { id: 'nlpWorkers', skip: true, nav: 'PDF Docs', name: 'Project Teams', ficon: '<i class="fa fa-file-text-o"></i>', type: { admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'nlpJobs', skip: false, ficon: '<i class="fa fa-server" aria-hidden="true"></i>', nav: 'Tasks', name: 'Tasks', type: { nlp_an: 1, nlp_qc: 1 } },
    { id: 'nlpAnnotations', skip: true, nav: 'PDF Docs', name: 'NERView', ficon: '<i class="fa fa-file-text-o"></i>', type: { nlp_an: 1, nlp_qc: 1, admin: 1, c_admin: 1, c_super: 1, c_viewer:1 , d_super: 1, d_viewer: 1 } },
    { id: 'bulkAnnotations', skip: true, nav: 'PDF Docs', name: 'Bulk Image Classification', ficon: '<i class="fa fa-file-text-o"></i>', type: { nlp_an: 1, nlp_qc: 1, admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'transcription', skip: true, nav: 'Media Transcription', name: 'TranscriptionView', ficon: '<i class="fa fa-file-text-o"></i>', type: { nlp_an: 1, nlp_qc: 1, admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'transcription2', skip: true, nav: 'AmEx Audio-Template', name: 'Transcription2View', ficon: '<i class="fa fa-file-text-o"></i>', type: { nlp_an: 1, nlp_qc: 1, admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'transcription3', skip: true, nav: 'Code Switching', name: 'Transcription3View', ficon: '<i class="fa fa-file-text-o"></i>', type: { nlp_an: 1, nlp_qc: 1, admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'poseestimation', skip: true, nav: 'Pose Estimation', name: 'PoseEstimationView', ficon: '<i class="fa fa-file-text-o"></i>', type: { nlp_an: 1, nlp_qc: 1, admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'segmentation', skip: true, nav: 'Segmentation', name: 'SegmentationView', ficon: '<i class="fa fa-file-text-o"></i>', type: { nlp_an: 1, nlp_qc: 1, admin: 1, c_admin: 1, c_super: 1 } },
    { id: 'keypoint', skip: true, nav: 'Key Point', name: 'KeyPointView', ficon: '<i class="fa fa-file-text-o"></i>', type: { nlp_an: 1, nlp_qc: 1, admin: 1, c_admin: 1, c_super: 1 } },

    { id: 'models', skip: false, name: 'Models', ficon: '<i class="fa fa-share-alt"></i>', type: { admin: 1, c_admin: 1 } },
    { id: 'modeledit', skip: true, name: 'Model Setup', ficon: '<i class="fa fa-sitemap" aria-hidden="true"></i>', type: { admin: 1, c_admin: 1 } },
    { id: 'companies', name: 'Companies', ficon: '<i class="fa fa-building" aria-hidden="true"></i>', type: { admin: 1 } },
    { id: 'companyedit', name: 'Company Settings', ficon: '<i class="fa fa-cogs" aria-hidden="true"></i>', type: { admin: 1, c_admin: 1 } },
    { id: 'companybilling', skip: true, name: 'Company Billing', ficon: '<i class="fa fa-credit-card-alt" aria-hidden="true"></i>', type: { admin:1, c_admin: 1 } },
    { id: 'users', name: 'Users', ficon: '<i class="fa fa-users" aria-hidden="true"></i>', type: { admin: 1, c_admin: 1 } },
    { id: 'dashboard', name: 'Dashboard', ficon: '<i class="fa fa-pie-chart" aria-hidden="true"></i>', type: { admin: 1, c_admin: 1 } },
    { id: 'userSetup', skip: true, name: 'Edit User', ficon: '<i class="fa fa-user-circle"></i>', type: { admin: 1, c_admin: 1 } },
    { id: 'userRole', skip: true, name: 'User Role', ficon: '<i class="fa fa-user-circle"></i>', type: { all: 1 } },
    { id: 'logs', name: 'Logs', ficon: '<i class="fa fa-clock-o" aria-hidden="true"></i>', type: { admin: 1 } },
    // {id:'test',name:'Test Dev',ficon:'<img className="svg-button" src="imgs/dashboard.png"/>',type:{admin:1}},
    { id: 'datasets_old', name: 'DatasetsOld', ficon: '<i class="fa fa-database"></i>', type: { imageds: 1 } },
    { id: 'images', name: 'Images', ficon: '<i class="fa fa-image"></i>', type: { imageds: 1 } },
    { id: 'selected', name: 'Selected', ficon: '<i class="fa fa-check-square"></i>', type: { imageds: 1 } },
    { id: 'accountSettings', skip: true, name: 'Account', ficon: '<i class="fa fa-cog"></i>', type: { all: 1 } },
    {
        id: "bcmApiKeys",
        skip: true,
        name: "Assessment API key",
        ficon: '<i class="fa fa-key"></i>',
        type: { c_admin: 1, admin: 1 },
    },
    { id: 'config', name: 'System Config', ficon: '<i class="fa fa-cog" aria-hidden="true"></i>', type: { admin: 1 } },
    { id: 'configDatasets', skip: true, name: 'Config Datasets', ficon: '<i class="fa fa-cog"></i>', type: { admin: 1 } },
    { id: 'datasetItems', skip: true, name: 'Dataset Items', ficon: '<i class="fa fa-database"></i>', type: { admin: 1, c_admin: 1, d_super: 1, d_viewer: 1, nlp_an: 1, nlp_qc: 1 } },
    { id: 'datasetAdvanced', skip: true, name: 'Global Dataset Item Search', ficon: '<i class="fa fa-database"></i>', type: { admin: 1, c_admin: 1, d_super: 1, d_viewer: 1, nlp_an: 1, nlp_qc: 1 } },
    { id: 'logout', skip: true, name: 'Logout', ficon: '<i class="fa fa-sign-out"></i>', type: { all: 1 } },
    { id: 'login', skip: true, name: 'Login', ficon: '<i class="fa fa-sign-in"></i>', type: { login: 1, } },
    { id: 'demo', name: 'Demo', ficon: '<i class="fa fa-sign-in"></i>', type: { login: 1, } },
    { id: 'charts', name: 'Charts', ficon: '<i class="fa fa-sign-in"></i>', type: { login: 1, } },
    { id: 'register', name: 'Register', ficon: '<i class="fa fa-sign-in"></i>', type: { login: 1, } },
   
     { id: '', name: 'support', ficon: '<img class="svg-button" src="imgs/new/support.png" onclick="window.openHelpLink()"/>', type: { admin: 1, c_admin: 1 } },
    //    { id: '', name: 'support', ficon: `<img class="svg-button" src="imgs/new/support.png" onclick="window.open(\'https://tensoractinc.freshdesk.com/support/tickets/new?email=[USER_EMAIL]&name=[USER_NAME]&subject=[SUBJECT]&description=[DESCRIPTION]\', \'_blank\')"/>`, type: { admin: 1, c_admin: 1 } },
    // { id: '', name: 'support', ficon: `<img class="svg-button" src="imgs/new/support.png" onclick="window.open(\'https://tensoractinc.freshdesk.com/support/tickets/new?email=${userEmail}&name=${user}&subject=[SUBJECT]&description=[DESCRIPTION]\', \'_blank\')"/>`, type: { admin: 1, c_admin: 1 } },
];


window.openHelpLink = function( params ) {
    if ( !params ) params = {};
    let global = window.GlobalVars;
    params.email = global.userEmail || '';
    params.name = global.userName || '';
    if( !params.subject ) params.subject = '[SUBJECT]';
    if( !params.description ) params.description = '[DESCRIPTION]';
    let url = 'https://tensoractinc.freshdesk.com/support/tickets/new?' + new URLSearchParams(params);
    console.log( url )
    window.open( url, '_blank')
}

window.DatasetTypes = {
    "Image": "Image",
    "PDF": "Native PDF",
    "Text": "Plain Text",
    // "PDFImage": "Scanned Text Document (old)",
    "PDFOCR": "Scanned (OCR)",
    "Video": "Video",
    "Audio": "Audio",
    "Csv":"Csv"
}


window.ProjectTypes = {
    "NER": "NER",
    "Comprehend NER": "Comprehend NER(Experimental)",
    "OCR": "OCR",
    "TEXT_QA": "Q&A",
    "Content Generation": "Content Generation",
    "Classification": "Classification",
    "Media Transcription": "Media Transcription",
    "AmEx Audio Templete": "AmEx Audio Templete",
    "Code Switching": "Code Switching",
    "Bulk Image Classification": "Bulk Image Classification",
    // "Pose Estimation": "Object Detection",
    "Pose Estimation": "Bounding Box",
    "Segmentation" : "Segmentation",
    "Key Point" : "Key Point",
     "Response Generation" : "Response Generation"
}

window.recipeTypes = {
    'Q&A': 'Q&A',
    'redaction': 'Redaction',
    'classification': 'Classification',
    'summarization': 'Summarization',
}

window.recipeActions = {
    'Q&A': 'Q&A',
    'redaction': 'Redact',
    'classification': 'Classify',
    'summarization': 'Summarize',
}


window.modelTypes = {
    custom_ner: 'NER Labeling', // custom_ner
    custom_ocr: 'OCR Labeling (Experimental)',
    custom_bulkimageclassification: 'Bulk Image Classification - Labeling',
    // sagemaker: 'Amazon SageMaker Labeling',
    ocr_extractor: 'OCR', //ocr_extractor,
}

// set dev mode
let isDev = window.isDev = true;

if (isDev) {
    window.modelTypes = {
        ...window.modelTypes,
        pii_redaction: 'PII Redaction',
        classification_prompt: 'Classification (Prompt)',
        summarization_prompt: 'Summarization (Prompt)',
        qa_prompt: 'Q&A (Prompt)',
        fallback_llm: 'Fix Response Format with LLM',
        text_embeddings: 'Text Embeddings',
        image_embeddings: 'Image Embeddings',
        video_embeddings: 'Video Embeddings',
        audio_embeddings: 'Audio Embeddings',
    }
}

window.deeplink = document.location.search.split(/[\?\&]/);
window.deeplink.shift();
if( window.deeplink.length ) {
    var [param,val] = window.deeplink[0].split('=');
    window.deeplink = param == 'dlkey' ? val : '';
}
else window.deeplink = '';

if( window.deeplink ) {
    document.body.className = 'deeplink';
}

window.projectWizzard = ['nlpProjectBrowse','nlpImport1','fileupload','nlpImport2','nlpImport3','nlpWorkers','nlpBrowse'];
window.datasetWizzard = ['datasetSetup', 'datasetUpload', 'datasetTeam', 'datasetItems', 'datasetRecipes', 'datasetChatBot', 'datasetModelRuns', 'datasetExports' ]

if( !isDev ) window.datasetWizzard = window.datasetWizzard.filter( v => !v.match(/(recipes|chatbot)/i) )
// window.datasetWizzard = ['datasetSetup', 'datasetUpload', 'datasetTeam', 'datasetItems', 'datasetModelRuns', 'datasetExports' ]

function getCurrentProjectMode()
{
    var pageId = (window.GlobalVars.pageMenu && window.GlobalVars.pageMenu.id) || null;
    var mode = window.projectWizzard.indexOf(pageId);
    if( mode < 1 ) mode = 1;
    return mode;
}

function getCurrentDatasetMode()
{
    var pageId = (window.GlobalVars.pageMenu && window.GlobalVars.pageMenu.id) || null;
    var mode = window.datasetWizzard.indexOf(pageId);
    // if( mode < 1 ) mode = 1;
    return mode;
}


window.wizzardBar = function(blank)
{
    var global = window.GlobalVars;
    // if( !global.PDFProjectActive ) return;
    var tnav = $('.top-nav').html('');
    var pageId = (window.GlobalVars.pageMenu && window.GlobalVars.pageMenu.id) || null;

    console.log( 'wizz', getCurrentDatasetMode(), global.currentDatasetId )
    if( getCurrentDatasetMode() >= 0 && global.currentDatasetId && window.hasPriv('admin', 'c_admin', 'd_super', 'd_viewer')) {
        var gDataset = global.currentDataset;
        var wizz = clone(window.datasetWizzard);
        console.log('datm', global.currentDataset.datasetType)
        if( !gDataset.datasetType.match(/(Text|PDF|PDFOCR)/) ) {
            wizz = wizz.filter((val)=> val != 'datasetRecipes')
        }
        if( !gDataset.currentRecipes || !gDataset.currentRecipes['Q&A'] || !gDataset.enableEmbeddingsModel ) {
            wizz = wizz.filter((val)=> val != 'datasetChatBot')
        }
        if( window.hasPriv('d_viewer')) wizz.splice(0,3)
        $('#pageTitle').html('Dataset: <span>'+global.currentDataset.datasetName+'</span>')
        wizz.forEach( (p,i) => {
            // if( !i ) return;
            var blabel = global.pageName[p].replace(/^Dataset /i, '');
            var b = $('<button>').html( blabel ).prop('page',p).addClass('wizz'+i);
            if( p == pageId ) b.addClass('top-nav-active');
            b.on('click', function(){ window.goPage( $(this).prop('page'), window.getParams())})
            tnav.append( b );
        })
    }
    else {
        var wizz = clone(window.projectWizzard)
        if( global.PDFProjectType == 'Bulk Image Classification' ) wizz.push( 'projectExports' )
        if( !global.PDFProjectActive ) return;
        console.log( 'PAGEID', pageId, wizz.indexOf(pageId) )
        global.pageName['nlpImport2'] = global.PDFProjectType == 'Classification' ? 'Classification Labels' : 'Labels & Relationships';
        if( window.hasPriv('c_viewer')) wizz.splice(0,5)
        if( wizz.indexOf(pageId) > 0 || pageId == 'nlpAnnotations' || pageId == 'transcription2' || pageId == 'transcription3'|| pageId == 'transcription' || pageId == 'poseestimation' || pageId=='segmentation') {
            if( window.hasPriv( 'admin', 'c_admin', 'c_super', 'c_viewer') )
            {
                if( global.PDFProjectName ) $('#pageTitle').html('Project: <span>'+global.PDFProjectName+'</span>')
                var mode = getCurrentProjectMode();
                wizz.forEach( (p,i) => {
                    if( !i ) return;
                    var blabel = global.pageName[p].replace(/^Project /i, '');
                    var b = $('<button>').html( blabel ).prop('page',p).addClass('wizz'+i);
                    if( p == pageId ) b.addClass('top-nav-active');
                    b.on('click', function(){ window.goPage( $(this).prop('page'), window.getParams())})
                    tnav.append( b );
                })
            } else {
                // if( global.PDFProjectName ) $('#pageTitle').html('Task Annotation')
                if( global.PDFProjectName ) $('#pageTitle').html('Project: <span>'+global.PDFProjectName+'</span>')
            }
        }
        if( global.PDFProjectType == 'Media Transcription' || global.PDFProjectType == 'AmEx Audio Templete' || global.PDFProjectType == 'Code Switching' ) $('.wizz3').hide();
        // if( global.PDFProjectType == 'Comprehend NER' ) $('.wizz2').hide();
        // if( global.PDFProjectType == 'OCR' ) $('.wizz2').hide();
    }
}

// var sss = window.setTimeout;
// if (!window.pathTimeout) {
//     window.pathTimeout = sss;
//     window.setTimeout = function (f, t) {
//         var tid = sss.apply(this, [f, t]);
//         // console.log('SETTIMEOUT', tid);
//     }
// }



window.wizzardButtons = function(hook, save)
{
    var global = window.GlobalVars;

    function cancelBtn()
	{
		window.goPage( window.projectWizzard[0] );
	}


	function backBtn()
	{
        if( save ) save( next );
        else next();
        function next(){
			var mode = getCurrentProjectMode();
			window.goPage( window.projectWizzard[mode-1] );
		}
	}

	function continueBtn()
	{
        
        if(window.GlobalVars.PDFProjectType === "TEXT_QA"){
            var CheckQAMandatory = CheckQA();
            if(!CheckQAMandatory){
                return false; 
            }
        }
        if( save ) save( next );
        else next();
        function next(){
			var mode = getCurrentProjectMode();
            // if( mode == 1 && (global.PDFProjectType == 'Comprehend NER' || global.PDFProjectType == 'OCR' || global.PDFProjectType == 'Bulk Image Classification') ) mode++; // skip file upload for comprehend ner projects
            // if( mode == 1 && (global.PDFProjectType == 'Bulk Image Classification') ) mode++; // skip file upload for comprehend ner projects  //dhinesh
             if( mode == 2 && (global.PDFProjectType === "Media Transcription"|| global.PDFProjectType == 'AmEx Audio Templete'|| global.PDFProjectType == 'Code Switching') ) mode++; 
 			window.goPage( window.projectWizzard[mode >= 4 ? window.projectWizzard.length-1 : mode+1] );
		}
	}
    
    var mode = getCurrentProjectMode();
    console.log('mode', mode )
    var prev = window.projectWizzard[mode-1];
    var next = window.projectWizzard[mode >= 3 ? window.projectWizzard.length-1 : mode+1];
    var prevName = ' <i class="fa fa-step-backward first mr-2"></i> Previous';
    var nextName = ' <i class="fa fa-step-forward last mr-2"></i> Next';
    // var prevName = global.pageName[prev].replace(/^Project /i, '');
    // var nextName = global.pageName[next].replace(/^Project /i, '');
    // for( var k in menu )
    // {
    //     if( menu[k].id == prev ) prevName = menu[k].name.replace(/^Project /i, '');
    //     if( menu[k].id == next ) nextName = menu[k].name.replace(/^Project /i, '');
    // } 
    if( mode <= 3 )
    {
        $(hook).html('<button id="cancelbtn" class="btn btn-secondary mr-2"><i class="fa fa-times-circle mr-2" aria-hidden="true"></i>Cancel</button><button id="backbtn" class="btn btn-primary mr-2 mt-0">Back</button><button id="continue" class="btn btn-pink mt-0">Continue</button>');
        $('#continue').html(nextName).on('click',continueBtn);
        $('#backbtn').html(prevName).on('click',backBtn);
        $('#cancelbtn').on('click',cancelBtn);
    }
    else
    {
        $(hook).html('<button id="cancelbtn" class="btn btn-secondary mr-2">Cancel</button><button id="continue" class="btn btn-primary">Continue</button>');
        $('#cancelbtn').on('click',cancelBtn);
        $('#continue').html('Save').on('click',continueBtn);
    }
}

window.topBarVisible = function() {
    if( $('.top-nav').html() == '' ) $('.top-nav').html('<button class="wizz1" style="margin-left: -100px" disabled>a</button>')
}

var defaultGlobal = {
    pages: pages,
    menu: menu,
    selected: {},
    filter: {},
    annotationGroups: ['Ground Truth','YoloV3'],
    // filter: {},
    params: {viewmode:0,prevmode:0,annotations:{'Ground Truth':true},size:32,bufferSize:256,detail:null,detailTarget:null},
};

function freeStorage()
{
    console.log( 'FREE STORAGE')
    var keys = Object.keys(localStorage);
    for( var i = 0 ; i < keys.length ; i++ )
        if( keys[i].match(/^cache_/))
        {
            console.log( 'cleaning localStorage', keys[i] )
            localStorage.removeItem(keys[i]);
            break;
        }
}

window.createId = function()
{
    var id = [];
    for( var i = 0 ; i < 24 ; i++ )
    id.push((Math.floor(Math.random()*0xffffff)%16).toString(16));
    return id.join('');
}

window.stateLabels = ['Unassigned', 'In Progress', 'Submitted for Review', 'In review', 'Approved', 'Rejected', 'Adjustment Requested', 'Submitted', 'Declined', '', '', '', 'Deleted', 'Pre-label-queue', 'Pre-labeling', 'Processing Error', 'Processing'];
window.stateLabelsAbv = [ 
    '<span class="abvtitle _state_0" title="Unassigned Tasks">Uns.</span>',  // 0
    '<span class="abvtitle _state_1" title="In Progress Tasks">Prog.</span>',  // 1
    '<span class="abvtitle _state_2" title="Submitted for Review Tasks">Sub. rev.</span>',  // 2
    '<span class="abvtitle _state_3" title="In review Tasks">Rev.</span>',  // 3
    '<span class="abvtitle _state_4" title="Approved Tasks">App.</span>',  // 4
    '<span class="abvtitle _state_5" title="Rejected Tasks">Rej.</span>',  // 5
    '<span class="abvtitle _state_6" title="Adjustment Requested Tasks">Adjs.</span>',  // 6
    '<span class="abvtitle _state_4" title="Submitted Tasks">Sub.</span>',  // 7
    '<span class="abvtitle _state_5" title="Declined Tasks">Decl.</span>',  // 8
    '<span class="abvtitle _state_0" title="reserved state"></span>',  // 9
    '<span class="abvtitle _state_0" title="reserved state"></span>',  // 10
    '<span class="abvtitle _state_0" title="reserved state"></span>',  // 11
    '<span class="abvtitle _state_5" title="Deleted"></span>',  // 12
    '<span class="abvtitle _state_0" title="Pre-labeling">Pre-lab.</span>',  // 13
    '<span class="abvtitle _state_0" title="Pre-labeling">Pre-lab.</span>',  // 14
    '<span class="abvtitle _state_5" title="Prossessing Error">Proc. Err.</span>',  // 15
    '<span class="abvtitle _state_0" title="Processing">Proc.</span>',  // 16
 ];


window.timeFromNow = function( ts )
{
    return frm.timeFromNow( ts )
    // if( !ts ) return '-';
    // var dt = Math.floor(Date.now()/1000)-ts;
    // if( dt < 60 ) return 'less than a minute';
    // if( dt < 3600 ) return Math.floor(dt/60) + ' minute' + (dt/60 > 2?'s':'');
    // if( dt < 86400 ) return Math.floor(dt/3600) + ' hour' + (dt/3600 > 2?'s':'');
    // return Math.floor( dt/86400 ) + ' day' + (dt/86400 > 2?'s':'');
}

window.download_logs = function() {
    window.post( 'downlogs', {}, res => {
        var data = res.data;
        document.location = data;
    })
}

window.timeFuture = function( ts )
{
    return frm.timeFuture(ts);
    // if( !ts ) return '-';
    // var dt = ts-Math.floor(Date.now()/1000);
    // if( dt < 0 ) return 'expired';
    // if( dt < 60 ) return 'less than a minute';
    // if( dt < 3600 ) return Math.floor(dt/60) + ' minute' + (dt/60 > 2?'s':'');
    // if( dt < 86400 ) return Math.floor(dt/3600) + ' hour' + (dt/3600 > 2?'s':'');
    // return Math.floor( dt/86400 ) + ' day' + (dt/86400 > 2?'s':'');
}


window.setCache = function( key, val )
{
    if( typeof(key) != 'string' ) key = JSON.stringify(key);
    key = 'cache_'+md5(key);
    var retry = 0;
    var ok = false;
    var save = {t: Date.now()+60*60*1000, data:val}
    while( !ok && retry++ < 100 )
    {
        try {
            localStorage.setItem(key,JSON.stringify(save));
            ok = true;
        } catch(e) {
            freeStorage()
        }
    }
}

window.addEvent = function( type, func )
{
    if( !window.addedEvents ) window.addedEvents = {};
    if( !window.addedEvents[type] ) window.addedEvents[type] = [];
    window.addedEvents[type].push( func );
    window.addEventListener( type, func, {passive: false} );
}

window.clearEvent = function( type )
{
    if( window.addedEvents && window.addedEvents[type] )
    window.addedEvents[type].forEach( f => window.removeEventListener(type,f) );
}

window.getCache = function( key )
{
    if( typeof(key) != 'string' ) key = JSON.stringify(key);
    key = 'cache_'+md5(key);
    var recover = localStorage.getItem(key);
    if( typeof(recover) == 'string' )
    {
        recover = JSON.parse(recover);
        if( recover.t < Date.now() ) return null;
        return recover.data;
    }
    return null;
}

window.resetProject = function() {
    var project = window.GlobalVars.PDFProjectId;
    window.post( 'reset_project', {project:window.GlobalVars.PDFProjectId}, res => {
        var data = res.data;
        alert( data.value );
        document.location.reload();
    } )
}

window.checkInNLP = function()
{
    // console.log( 'checkInNLP', document.getElementById('maincolumn') );
	if( !document.getElementById('maincolumn') )
	{
		document.body.style.overflow='auto';
	}
	else {
        setTimeout( window.checkInNLP, 500 );
	}
}


window.delCache = function( key )
{
    if( typeof(key) != 'string' ) key = JSON.stringify(key);
    key = 'cache_'+key;
    console.log( 'delCache', key );
    localStorage.removeItem(key);
}

window.clearCache = function()
{
    var keys = Object.keys(localStorage);
    keys.forEach( k => {
        console.log( 'REMOVE CACHE', k )
        if( k.match(/^cache_/)) localStorage.removeItem(k);
    })
}

var sessionTid = null;
if( !window.sessionDuration )
window.sessionDuration = document.location.href.indexOf('localhost') >= 0 ? 60*6 : 15;
var saveSessionCallback = null;

window.saveSession = function (callback) {
    let _p_callback = callback;
    return new Promise(async (resolve, reject) => {
        let callback = function () {
            if (_p_callback) _p_callback.apply(this, arguments);
            resolve.apply(this, arguments);
        }
        clearTimeout(sessionTid);
        if (callback) saveSessionCallback = callback;
        sessionTid = setTimeout(function () {
            window.GlobalVars.expireTime = Date.now() + 1000 * 60 * window.sessionDuration;
            try {
                localStorage.setItem('session', JSON.stringify(window.GlobalVars));
                if (saveSessionCallback) {
                    saveSessionCallback();
                }
                saveSessionCallback = null;
            } catch (e) {
                console.error(e)
                freeStorage();
            }
            console.log('session saved')
        }, 100);
    });
}

window.clearSession = function()
{
    window.clearCache();
    window.GlobalVars.selected = {};
    window.GlobalVars.filter = {};
    delete window.GlobalVars.fullDataset;
    window.saveSession();
}

window.endSession = function()
{
    localStorage.clear();
    sessionStorage.clear();
    clearTimeout(sessionTid);
    // window.clearSession();
    // for( var k in window.GlobalVars )
    // {
    //     delete window.GlobalVars[k];
    // }
    // var dg = window.clone(defaultGlobal);
    // for( var k in dg )
    // {
    //     window.GlobalVars[k] = dg[k];
    // }
    delete window.GlobalVars.sessionId;
    delete window.GlobalVars.expireTime;
    delete window.GlobalVars.user;
    delete window.GlobalVars.userName;
    delete window.GlobalVars.userPriv;
    window.GlobalVars.filter = {};
    window.GlobalVars.selected = {};
    window.GlobalVars.params = window.clone(defaultGlobal.params);
}


var stopped = false;
function stop() {
    stopped = true;
}

window.sessionLoaded = false;
window.loadSession = function( defaultVal )
{

    var sess = localStorage.getItem('session');
    if( !sess ) sess = defaultVal;
    else {
        sess = JSON.parse(sess);
        if( Date.now() > sess.expireTime ){
            console.log( 'session expired' );
            sess = defaultVal;
        }
        else {
            sess.expireTime = Date.now()+(window.sessionDuration*60)*1000;
            console.log( 'EXP', new Date(sess.expireTime))
        }
    }
    for( var k in sess )
    {
        if( typeof(sess[k]) == 'function' ) delete sess[k];
    }
    sess.menu = menu;
    window.GlobalVars = sess;
    // alert( 'LOADDDDDDD ' + sess.params.start )
    var page = getPage(true) || ''; // get raw page; 
    console.log('page----------->',page);
    

    if( window.deeplink && !window.GlobalVars.dlkey 
        || !window.deeplink && window.GlobalVars.dlkey 
        || (window.deeplink && window.deeplink != window.GlobalVars.dlkey ) ) {
            if( !window.deeplink ) window.deeplink = window.GlobalVars.dlkey
            else window.GlobalVars.userSession = window.deeplink;
        setTimeout( function(){
            window.post('deep_link', {dlid:window.deeplink}, res => {
                console.log('DEEPLINK', JSON.stringify(res.data))

                var global = window.GlobalVars;
                var data = res.data;
                if( data.expireLink && data.expireLink < Date.now() ) {
                    $(document.body).html('<div class="linkexpired">Link Expired</div>');
                    window.endSession();
                    return;
                }
                if( data.processing ) {
                    $(document.body).html('<div class="linkexpired">This task is still being processed. Please try again later.</div>');
                    return;
                }
                global.user = 'deeplink';
                global.userEmail = data.email;
                global.userName = data.name;
                global.userSession = data.sid;
                global.userPriv = frm.arr2Bool((data.priv || data.roles[0].priv));
                global.userCompany = data.company || data.roles[0].company;
                global.userCurrentRole = data.currentRole;
                global.usersupervisedProject = data.supervisedProject;
                global.sessionId = data.sid;
                global.dlkey = window.deeplink;
                global.expireLink = data.expireLink;
                global.PDFFileId = data.taskId;
                global.PDFProjectType = data.projectType;
                global.PDFRole = data.role;
                global.deepLinkReturnURL = data.returnURL;
                var page = data.projectType == 'Media Transcription' ? 'transcription' : 'transcription2';
                 page = data.projectType == 'AmEx Audio Templete' ? 'transcription2' : 'transcription3';                page = menu.find( m => m.id == page ).name;
                 page = data.projectType == 'Code Switching' ? 'transcription3' : 'nlpAnnotations';                page = menu.find( m => m.id == page ).name;
                global.params = { start: page }
                window.saveSession(function () {
                    var url = '/?dlkey='+window.deeplink+'&t='+Date.now()+'#'+page;
                    document.location = url;
                });
            })
        }, 1 )
        return stop();
    }
    if( stopped ) return;
    // if( (
    //         (window.deeplink && window.GlobalVars.dlkey != window.deeplink ) 
    //         || (!window.deeplink && window.GlobalVars.dlkey  ) 
    //     )
    //     && !document.location.toString().match(/login/i)) {
    //         console.log( 'DEEPLINKERROR', 'dl', window.deeplink, 'dlkey', window.GlobalVars.dlkey)
    //     // window.endSession();
    //     // document.location = '#Login';
    //     // document.location = 'https://facebook.com';
    //     return stop();
    // }
    if( window.deeplink && !page.match(/^(nlpAnnotations|transcription|login)$/) ) {
        window.endSession();
        setTimeout( function(){ window.login(); }, 1 );
        return stop();
    }
    
    console.log( 'LOADSESSION', page );
    window.saveSession();
    window.sessionLoaded = true;
    // alert( JSON.stringify(window.GlobalVars))
    if( page > '')
    setTimeout( function(){ window.go(page)}, 100 )
}

window.loadSession( window.clone(defaultGlobal) );


window.setSelected = function( id, v )
{
    if( id )
    {
        window.GlobalVars.selected[id] = v;
        // else delete window.GlobalVars.selected[id];
        window.saveSession();
    }
}

window.postParams = function (pdata) {
    if (!pdata) pdata = {};
    pdata = clone(pdata);
    if (window.GlobalVars.userSession) pdata.sid = window.GlobalVars.userSession;
    for (var k in pdata) {
        if (isobj(pdata[k]) || isarray(pdata[k])) {
            try {
                pdata[k] = JSON.stringify(pdata[k]);
            }
            catch (e) { }
        }
    }
    return pdata;
}

window.postURL = function( cmd )
{
    var loc = document.location;
    var url = loc.protocol + '//' + loc.hostname + ':8088/'+cmd;
    if( window.servicePath ) url = window.servicePath+cmd;
    if( loc.hostname.toString().match('adl.objectways.com') ) url = 'https://adlservice.objectways.com/' + cmd;
    return url;
}

window.postTop = function( cmd, pdata ) {
    var url = window.postURL( cmd );
    pdata = window.postParams( pdata );
    var xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify(pdata));
}


window.login = function() {
    var page = getPage(1);

    var baseUrl = document.location.origin + '/';

    var params = window.getPageParams();
    var next = document.location
    var unext = btoa(next)
    if( !page || page.match(/(login|logout|userRole)/) ) unext = '';
    // console.trace( 'LOGIN')
    // return;
    document.location = baseUrl + '?next=' + unext + '#Login';
}

function downloadPost(name, data) {
    var blob = new Blob([JSON.stringify(data, null, '\t')], { type: "text/plain;charset=utf-8" });
    var url = window.URL.createObjectURL(blob);

    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.setAttribute("download", 'track.' + name + ".json");
    a.click();
    window.URL.revokeObjectURL(url);
}

window.downloadPost = downloadPost;

window.postTrail = []
window._trackingPosts = JSON.parse( localStorage.getItem('trackingPosts') || 'false' );
async function tPost( cmd, pdata ) {
    if( cmd.match(/(fetchPresign|task_thumb)/) ) return;
    return new Promise( async (resolve, reject) => {
        window.postTrail.push( {
            function: cmd,
            payload: pdata,
        })
        if( window._trackingPosts ) {
            downloadPost( cmd, pdata );
        }
        resolve();
    });
}

window.trackPosts = function( v ) {
    window._trackingPosts = v === 0 || v === false ? false : true;
    localStorage.setItem('trackingPosts', window._trackingPosts )
    console.log(window._trackingPosts ? 'TRACK POSTS is ON' : 'TRACK POSTS is OFF');
    if( window.getPage() == 'Dataset Upload' ) {
        document.location.reload();
    }
}

window.post = async function (cmd, pdata, callback) {
    let _p_callback = callback;
    return new Promise(async (resolve, reject) => {
        let callback = function () {
            if (_p_callback) _p_callback.apply(this, arguments);
            resolve.apply(this, arguments);
        }
        let odata = clone(pdata);
        // console.log( 'ODATA', odata )
        // alert( cmd )
        // console.log('POST', cmd);
        // var loc = document.location;
        // var url = loc.protocol + '//' + loc.hostname + ':8088/'+cmd;
        // if( loc.hostname.toString().match('adl.objectways.com') ) url = 'https://adlservice.objectways.com/' + cmd;
        var url = window.postURL(cmd);
        // console.log('POST url', url, cmd)
        // console.log( 'POST', url, 'CMD', cmd, 'POSTDATA', pdata )

        var getData = [];
        pdata = window.postParams(pdata);
        // console.log( 'PDATA', pdata )
        for (var k in pdata) getData.push(k + '=' + escape(pdata[k]));
        console.log('POST', url + '/?' + getData.join('&'))
        console.log('pdata', pdata)
        axios.post(url, pdata).then(res => {
            // console.log( 'urlllllllllllllll', url )
            if (res.data == "forcelogout" && window.GlobalVars.userId) {
                setTimeout(function () {
                    localStorage.clear();
                    window.GlobalVars = {};
                    window.login();
                }, 1000);
                return;
            }
            // console.log( 'CALLBACK', callback )
            if( pdata.sid ) odata.sid = pdata.sid;
            tPost( cmd, odata );
            callback(res);
        }).catch(err => {
            // Handle error
            console.error(err);
            if (pdata.noretry) return;
            setTimeout(function () {
                window.post(cmd, pdata, callback)
            }, 1000)
            // callback(null);
        });;
    });

}


window.getPossibleLabels = function( recs )
{
    var keys = {};
    var dataset = window.GlobalVars.params.dataset_name;
    if( !recs ) return;
    recs.forEach( r => {
        if( dataset && r.name != dataset ) return;
        for( var k in r.keys )
        {
            if( !keys[k] ) keys[k] = r.keys[k];
            else keys[k] += r.keys[k];
        }
    });
    var klist = [];
    var knames = Object.keys(keys);
    knames.sort();
    knames.forEach( k => {
        klist.push( {name:k, count:keys[k]} );
    })
    window.GlobalVars.possibleLabels = klist;
    window.saveSession();
}

window.uploadButton = function( button, accept, callback )
{
    button = $(button);
    if( button.prop('input') )  button.prop('input').remove();
    var input = $('<input type="file" id="fileinput"/>');
    if( accept ) input.attr('accept', accept );
    button.unbind('click').on('click', function(){ input.click() })
    button.after(input);
    button.prop('input', input );
    input.css({
        display: 'none',
    });
    input.on('change', function(ev){
        var finpt = ev.target
        if( !finpt.files.length ) return;
        var fr = new FileReader();
        console.log( 'FILE', finpt.files[0]  )
        fr.onload = function()
        {
            var res = fr.result;
            res = res.substring(res.indexOf(',')+1)
            callback( res, finpt.files[0].name, finpt.files[0].lastModified );
            setTimeout( function(){
                window.uploadButton( button, accept, callback  );
            }, 100 )
        }
        fr.readAsDataURL(finpt.files[0]);
    })
}


window.goPage = function(p,params)
{
    // alert( p )
    var m = window.GlobalVars.menu || [];
    if( !p )
    {
        function ckPriv( page, priv )
        {
            if( page.type.all ) return true;
            if( !priv ) return false;
            var type = Object.keys(page.type);
            for( var i = 0 ; i < type.length ; i++ )
                if( type[i] in priv ) return true;
            return false;
        }
        var firstMenu = null;
        m.forEach( mi => {
            mi.show = ckPriv(mi,window.GlobalVars.userPriv);
            if( mi.show && !firstMenu ) firstMenu = mi.name;
        });
        p = firstMenu;
        if( p != 'User Role' && typeof(window.GlobalVars.postLogin) == 'string' ) {
            var url = window.GlobalVars.postLogin;
            delete window.GlobalVars.postLogin;
            setTimeout( function(){
                window.saveSession( function() {
                    document.location = url;
                })
            }, 1 )
            return;
        }
    }
    if( !params )
        var baseUrl = document.location.origin + '/';
    else {
        var plist = btoa( JSON.stringify(params) )
        var baseUrl = document.location.origin + '?params=' + plist;
    }
    for( var i = 0 ; i < m.length ; i++ )
    {
        if( m[i].name == p || m[i].id == p )
        {
            // AQUI
            // alert(baseUrl + '#'+m[i].name)
            document.location = baseUrl + '#'+m[i].name;
            // document.location.reload();

            return;
        }
    }
    window.login();
}

window.projectParams = function(p){
    var ret = {
        ptype: 'proj',
        id:p.id,
        type:p.type,
        name:p.name,
        company:p.company,
        role:p.role || null,
        active: p.active,
    }
    return ret;
}

var pageParams = null;
window.getParams = function() {
    if( pageParams ) return pageParams;
    var cfg = window.getPageParams();
    if( cfg.params ) {
        var params = JSON.parse(atob(cfg.params));
        console.log( 'getParams', params )
        function setGlobal( v, gk ) {
            if( v in params ) {
                window.GlobalVars[gk] = params[v] || null;
                console.log( 'set', gk, params[v])
            }
        }
        if( params.ptype == 'proj' ) {
            setGlobal( 'id', 'PDFProjectId')
            setGlobal( 'type', 'PDFProjectType')
            setGlobal( 'name', 'PDFProjectName')
            setGlobal( 'company', 'PDFProjectCompany')
            setGlobal( 'role', 'PDFRole')
            setGlobal( 'active', 'PDFProjectActive')
            setGlobal( 'fileId', 'PDFFileId')
            window.saveSession();
        }
        else if( params.ptype == 'datasetDetail' ) {
            setGlobal( 'project', 'PDFProjectId')
            setGlobal( 'projectType', 'PDFProjectType')
            setGlobal( 'projectName', 'PDFProjectName')
            setGlobal( 'projectCompany', 'PDFProjectCompany')
            setGlobal( 'fileId', 'PDFFileId')
            setGlobal( 'itemId', 'PDFItemId')
            window.GlobalVars.PDFRole = null;
        }
        return params;
    }
    return {};
}

window.setParams = function( p ) {
    pageParams = p;
}

var setNavActiveTid = null;
window.setNavActive = function(pageId, title)
{
    if( pageId )
    {
        clearTimeout( setNavActiveTid );
        setNavActiveTid = setTimeout( function(){
            $('.menu-side').removeClass('active');
            $('.menu-'+pageId).addClass('active');
        },100 );
    }
}

window.privs = {
    'admin': 'SuperUser',
    'c_admin': 'Company Admin',
    'c_super': 'Project Supervisor',
    'c_viewer': 'Project Viewer',
    'nlp_an': 'Annotator',
    'nlp_qc': 'Reviewer (QC)',
    'd_super': 'Dataset Supervisor',
    'd_viewer': 'Dataset Viewer',
    // 'imageds': 'Image Browser',
    // 'im_an': 'Image Annotator',
    // 'im_qc': 'Image QC',
    'api': 'API User',
    // 'user': 'Normal User',
}

window.hasPriv = function()
{
    try {
        var privs = Array.from(arguments);
        for( var i = 0 ; i < privs.length ; i++ )
            if( window.GlobalVars.userPriv[privs[i]] > 0 ) return true;
        // console.log( 'hasPriv', window.GlobalVars.userPriv, p, window.GlobalVars.userPriv[p])
        return false;
    }
    catch(e) { return false; }
}

window.menuPriv = function()
{
    var global = window.GlobalVars;
    if( !global.menu ) return;
    var page = unescape(document.location.hash.substr(1));

    var priv = page == 'Login' ? {login:1} : global.userPriv;

    function ckPriv( page, priv )
    {
        // if( page.skip ) return false;
        if( page.type.all ) return true;
        if( !priv ) return false;
        var type = Object.keys(page.type);
        for( var i = 0 ; i < type.length ; i++ )
            if( type[i] in priv ) return true;
        return false;
    }
    var firstMenu = null;
    var menus = {};
    global.pageName = {};
    global.menu.forEach( m => {
        global.pageName[m.id] = m.name;
        m.show = ckPriv(m,priv);
    });
    global.pages.splice( 0, 1000 );
    menu.forEach( (m) => { if( m.show ) {menus[m.name] = m; global.pages.push(m.name)} } );
    // alert( JSON.stringify(menus) );
    return menus;
}

function getPageParams(){
    var spar = document.location.search.split('?');
    if( spar.length < 2) return {};
    var ret = {};
    var list = spar[1].split('&')
    for( var l of list ) {
        var lk = l.split('=');
        var key = lk.shift();
        var val = lk.join('=');
        ret[key] = decodeURI(val);
    }
    return ret;
}


window.getPageParams = getPageParams;

function getPage(raw)
{
    console.log( 'getPage', raw )
    if( stopped ) return;
    console.log('window.globalvars---->',window.GlobalVars);
    
    var global = window.GlobalVars;
    if( raw && global.menu ) {
        var page = unescape(document.location.hash.substr(1))
        
        // for( var m of global.menu ) {
        //     if( m.name == page ) return m.id;
        // }
        for (var m of global.menu) {
            if (m.name === page) {
                console.log('m.name--->',m.name);
                console.log('page--->',page);
                console.log('m.id---->', m.id);
                return m.id;  // If you need to return m.id, otherwise just remove this line.
            }
        }
        
        return null;
    }


    if( !global.menu ) global.menu = []
    if( !global.pages ) global.pages = []
    var page = unescape(document.location.hash.substr(1));
    var priv = page == 'Login' ? {login:1} : global.userPriv;
    // alert( JSON.stringify(priv))
    function ckPriv( page, priv )
    {
        if( page.type.all ) return true;
        if( !priv ) return false;
        var type = Object.keys(page.type);
        for( var i = 0 ; i < type.length ; i++ )
            if( type[i] in priv ) return true;
        return false;
    }
    var firstMenu = null;
    global.menu.forEach( m => {
        m.show = ckPriv(m,priv);
        if( m.show && !firstMenu ) firstMenu = m.name;
    });

    var menus = window.menuPriv();
    global.menus = menus;
    var page = unescape(document.location.hash.substr(1))
    if( page == '' )
    {
        page = global.pages[0];
        if( window.GlobalVars.userEmail ) document.location = '#' + page;
    }
    // console.log( 'pages:' + JSON.stringify(pages) );
    // if( global.pages.indexOf(page) < 0 )
    //     page = 'notfound';
    // else
        window.GlobalVars.pageMenu = menus[page];
        window.GlobalVars.page = page;
        window.GlobalVars.pageId = (menus[page] && menus[page].id) || null;
        // console.log( 'getPage', window.GlobalVars.userPriv, page )
    // console.log( 'window.GlobalVars', window.GlobalVars );
    return page;
}
getPage();
window.getPage = getPage;

function checkPage()
{
    if( stopped ) return;
    var page = unescape(document.location.hash.substr(1));
    if( page != window.GlobalVars.page && window.GlobalVars.page != 'notfound' )
    {
        // document.location.reload();
    }
    setTimeout( checkPage, 2000 );
}

checkPage();

function topCollapse( v, noevent ) {
    if( typeof(v) == 'undefined' ) {
        v = localStorage.getItem('collapseState') || 0;
        v *= 1;
    }
    function fireResize(){
        var event = new CustomEvent("resize"); 
        window.dispatchEvent(event)
    }
    setTimeout( function(){
        var icons = ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>']
        // var icons = ['<i class="fa fa-angle-double-left"></i>', '<i class="fa fa-angle-double-right"></i>']  12/4 mani
        //'<i class="bi bi-chevron-left"></i>','<i class="bi bi-chevron-right"></i>'
        // var icons = [ '<i class="bi bi-chevron-left"></i>','<i class="bi bi-chevron-right"></i>']
        $('.top_switch').html(icons[v])
    }, 100 )
    if( v ) {
        $('.mainnav').addClass('top_collapse')
        $('.sidebar').addClass('left_collapse')
        $('.maincontent').addClass('main_collapse')

        setTimeout( fireResize, 100 )
        $('.top_switch').attr('title','Click to show navigation bars')
    } else {
        $('.mainnav').removeClass('top_collapse')
        $('.sidebar').removeClass('left_collapse')
        $('.maincontent').removeClass('main_collapse')
        $('.top_switch').attr('title','Click to hide navigation bars')
        setTimeout( fireResize, 100 )
    }
    $('.top_switch').prop('mode',v);
    $('.top_switch').off('click').on('click', function(){
        var mode = $('.top_switch').prop('mode');
        topCollapse( 1-mode );
    });
    localStorage.setItem('collapseState', v )
}


window.ggg = window.GlobalVars;

function App() {
    const [global, setGlobal] = useState(window.GlobalVars);
    const [stopped, setStopped] = useState(false);

    useEffect(() => {
        // Sanitize all input tags globally
        const inputElements = document.querySelectorAll('input[type="text"]');
        inputElements.forEach((input) => {
            input.addEventListener('change', () => {
                sanitizeInput(input);
            });
        });

        // Clean up event listeners on unmount
        return () => {
            inputElements.forEach((input) => {
                input.removeEventListener('change', () => {
                    sanitizeInput(input);
                });
            });
        };
      
    }, []); 

    useEffect(() => {
        topCollapse();
    }, []);
    
    if (stopped) return null;

    window.GlobalVars.update = function(justRedraw) {
        getPage();
        window.GlobalVars.searchDone = false;
        var newGlobal = { ...window.GlobalVars };
        if (window.GlobalVars.setResult && !justRedraw) {
            window.GlobalVars.setResult(null);
        }
        newGlobal.tmp = Math.random();
        setGlobal(newGlobal);
    };

    window.GlobalVars.clearSearch = function() {
        if (window.GlobalVars.setSearch) {
            window.GlobalVars.setSearch('');
        }
        window.GlobalVars.params.search = '';
    };

    return (
            <>
            <div className="top_switch"></div>
            <MySideNav global={global}/>
                <div className="mainnav">
                <MyNav global={global}/>
                </div>
                    <Content global={global}/>
            </>
    );
    // return (
    //     <>
    //     <MySideNav global={global}/>
    //     <div className="mainnav">
    //     <MyNav global={global}/>
    //     </div>
    //     <Content global={global}/>
    //     </>
    // );
}

export default App;
